import { render, staticRenderFns } from "./HandworkTable.vue?vue&type=template&id=72c11300&"
import script from "./HandworkTable.vue?vue&type=script&lang=js&"
export * from "./HandworkTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports